var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import { HttpClient } from '@angular/common/http';
import * as moment from 'moment';
import { disabledProgress } from '../config/progress.inteceptor';
var DashboardService = /** @class */ (function () {
    function DashboardService(http) {
        this.http = http;
    }
    DashboardService.prototype.getInboundQueue = function (msisdns) {
        return this.http.get("/inbound/queue", __assign({ params: { msisdns: msisdns ? msisdns.toString() : '' } }, disabledProgress));
    };
    DashboardService.prototype.getInboundStats = function (msisdns) {
        return this.http.get("/inbound/statistics", __assign({ params: { msisdns: msisdns ? msisdns.toString() : '', timezoneOffsetMinutes: "" + moment().utcOffset() } }, disabledProgress));
    };
    DashboardService.prototype.getWorkingUsersInbound = function (msisdns) {
        return this.http.get("/users/working-inbound", __assign({ params: { msisdns: msisdns ? msisdns.toString() : '', timezoneOffsetMinutes: "" + moment().utcOffset() } }, disabledProgress));
    };
    DashboardService.prototype.getCallVolume = function (dashboardType) {
        return this.http.get("/dashboard", __assign({ params: { dashboardType: dashboardType, timezoneOffsetMinutes: "" + moment().utcOffset(), rangeDays: '30' } }, disabledProgress));
    };
    return DashboardService;
}());
export { DashboardService };
